module.exports = __webpack_public_path__ + "static/media/SimAgile_Instructor_Guide.69f2a3f8.pdf";